<template>
  <div class="all-box zfMsg-box zfmsg-container">
    <Header :title="title" />
    <section class="dzclubs-all-wrap userinfo-bm-input zfMsg-bm-input">
      <el-row class="dzclubs-item-wrap" style="margin: auto">
        <img src="@/assets/zfHeader.png" alt="" />
        <el-col :span="24" class="zfMsg-items abs">
          <div class="zfMsg-items-header">
            <img src="@/assets/equityIcon.png" alt="" />
            <p>新民祝福语权益</p>
          </div>
          <div
            class="zfMsg-items-btn"
            v-if="
              zfView == 1 && (zfMsgForm.jifen >= 720 || zfMsgForm.new_vip > 0)
            "
          >
            <el-button @click="sendZf">送祝福</el-button>
          </div>
          <div class="zfMsg-items-btn" v-if="zfView == 4">
            <el-button @click="zfView = 1">返回列表</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row class="dzclubs-item-wrap">
        <ZfList
          :sendZf="sendZf"
          :zfLists="zfLists"
          :zfMsgFormJifen="zfMsgForm.jifen"
          :zfMsgFormCount="zfMsgForm.wish_count"
          :zfMsgFormVip="zfMsgForm.new_vip"
          :showZfOrderId="showZfOrderId"
          v-if="zfView == 1"
        />
        <ZfSend
          :zfMsgForm="zfMsgForm"
          :submitSend="submitSend"
          :canSubmit="canSubmit"
          v-if="zfView == 2"
        />
        <ZfUpdate
          :zfMsgForm="zfMsgForm"
          :zfLists="zfLists"
          :zfConfirm="zfConfirm"
          :submitBack="submitBack"
          :canConfirm="canConfirm"
          :zfView="zfView"
          :showZfOrderIdKey="showZfOrderIdKey"
          v-if="zfView == 3 || zfView == 4"
        />
      </el-row>
    </section>
  </div>
</template>

<script>
import Header from "@/components/util/Header";
import ZfList from "@/views/services/zfmsg/components/ZfList";
import ZfSend from "@/views/services/zfmsg/components/ZfSend";
import ZfUpdate from "@/views/services/zfmsg/components/ZfUpdate";

import qs from "qs";

export default {
  name: "ZfMsg",
  data() {
    return {
      title: "祝福语",
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      wx: {
        uid: 0,
        openid: "",
        nickname: "",
        headimgurl: "",
        userToken: "",
      },
      zfLists: [],
      zfView: 1,
      zfMsgForm: {
        realname: "", //姓名
        phone: "", //手机号
        content: "", //祝福语
        wish_date: "", //祝福日期
        wish_type: "生日祝福", //祝福类型
        number: 0, //订单编号
        jifen: 0,
        wish_count: 0,
        wish_date_list: [],
        wish_type_list: ["生日祝福", "结婚纪念", "衷心祝福", "衷心感谢"],
        new_vip: 0,
      },
      rules: {
        wish_date: [
          { required: false, message: "选择日期", trigger: "change" },
        ],
        wish_type: [
          { required: false, message: "选择祝福语类型", trigger: "change" },
        ],
        content: [
          { required: false, message: "请填写祝福语", trigger: "blur" },
        ],
        realname: [{ required: false, message: "请填写姓名", trigger: "blur" }],
        phone: [{ required: false, message: "请填写手机号", trigger: "blur" }],
      },
      canSubmit: false,
      canConfirm: false,
      showZfOrderIdKey: 0,
      storage: window.localStorage,
    };
  },
  mounted() {
    this.wx.uid = this.storage.getItem("uid");
    this.wx.userToken = this.storage.getItem("usertoken");
    this.getZfList();
    this.getWishDate();
    this.getInfo();
  },
  methods: {
    getZfList() {
      this.$axios
        .get(`/wxindex/bestwish/wishlist.html`, {
          params: {
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.zfLists = response.data.datas;
          } else {
            window.location.href =
              "https://clubs.xinmin.cn/dzclub/index.html#/auth";
          }
        });
    },
    getWishDate() {
      this.$axios
        .get(`/wxindex/bestwish/getwishdate.html`, {
          params: {
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.zfMsgForm.wish_date_list = response.data.dates;
          } else {
            window.location.href =
              "https://clubs.xinmin.cn/dzclub/index.html#/auth";
          }
        });
    },
    getInfo() {
      this.$axios
        .get(`/wxindex/user/getinfo.html`, {
          params: {
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.zfMsgForm.realname = response.data.userinfo.realname;
            this.zfMsgForm.phone = response.data.userinfo.phone;
            this.zfMsgForm.jifen = response.data.userinfo.jifen;
            this.zfMsgForm.wish_count = response.data.userinfo.wish_count;
            this.zfMsgForm.new_vip = response.data.userinfo.new_vip;
          } else {
            window.location.href =
              "https://clubs.xinmin.cn/dzclub/index.html#/auth";
          }
        });
    },
    sendZf() {
      this.zfView = 2;
    },
    submitSend() {
      /*验证*/
      this.$axios
        .post(
          `/wxindex/bestwish/addwishTest.html`,
          qs.stringify({
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
            realname: this.zfMsgForm.realname,
            phone: this.zfMsgForm.phone,
            content: this.zfMsgForm.content,
            wish_date: this.zfMsgForm.wish_date,
            wish_type: this.zfMsgForm.wish_type,
          })
        )
        .then((response) => {
          if (response.data.status) {
            this.canSubmit = true;
            this.zfView = 3;
            this.$message.success({
              message: response.data.message,
              type: "success",
              center: true,
              offset: 90,
              duration: 1500,
              customClass: "message-class",
            });
            setTimeout(() => {
              this.canSubmit = false;
            }, 1500);
          } else {
            this.canSubmit = true;

            this.$message.warning({
              message: response.data.message,
              type: "warning",
              center: true,
              offset: 90,
              duration: 1500,
              customClass: "message-class",
            });
            setTimeout(() => {
              this.canSubmit = false;
            }, 1500);
          }
        });
    },
    zfConfirm() {
      this.$axios
        .post(
          `/wxindex/bestwish/addwish.html`,
          qs.stringify({
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
            realname: this.zfMsgForm.realname,
            phone: this.zfMsgForm.phone,
            content: this.zfMsgForm.content,
            wish_date: this.zfMsgForm.wish_date,
            wish_type: this.zfMsgForm.wish_type,
          })
        )
        .then((response) => {
          if (response.data.status) {
            this.canConfirm = true;
            this.zfView = 1;
            this.zfMsgForm.content = "";
            this.zfMsgForm.wish_date = "";
            this.zfMsgForm.wish_type = "生日祝福";
            this.getZfList();

            this.$message.success({
              message: response.data.message,
              type: "success",
              center: true,
              offset: 90,
              duration: 1500,
              customClass: "message-class",
            });
            setTimeout(() => {
              this.canConfirm = false;
            }, 1500);
          } else {
            this.canConfirm = true;

            this.$message.warning({
              message: response.data.message,
              type: "warning",
              center: true,
              offset: 90,
              duration: 1500,
              customClass: "message-class",
            });
            setTimeout(() => {
              this.canConfirm = false;
            }, 1500);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    submitBack() {
      this.zfView = 2;
    },
    showZfOrderId(key) {
      this.showZfOrderIdKey = key;
      this.zfView = 4;
    },
  },
  components: {
    Header,
    ZfList,
    ZfSend,
    ZfUpdate,
  },
};
</script>

<style scoped>
.zfmsg-container {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.zfmsg-container .header-wrap {
  background-color: var(--f56c6c);
  color: var(--fff);
}

.zfMsg-items {
  width: 100%;
  left: 0;
  right: 0;
  margin: auto;
  overflow: hidden;
}

.zfMsg-items img {
  margin: 0 10px;
  width: 18px;
}

.zfMsg-items p {
  color: var(--fff);
  font-size: 20px;
  line-height: 1;
}

.zfMsg-items-btn button,
.zfMsg-items-btn .el-button:focus,
.zfMsg-items-btn .el-button:hover {
  min-width: 80px;
  color: var(--equity-header-btn-color);
  background-color: var(--equity-header-btn-bgcolor);
  border-radius: 10px;
  border: transparent;
  border-color: transparent;
}

.zfMsg-items {
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  width: 96%;
  height: 100%;
  margin: auto;
}

.zfMsg-items-header {
  display: -webkit-flex;
  position: relative;
  justify-content: center;
  align-items: flex-start;
  height: 70%;
}
</style>